import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { OnboardingSignupRequest, OnboardingSignupResponse } from 'src/api/onboardingSignup';

// This endpoint synchronously creates a Company, runs its tenant schema migration, and
// creates its admin User - a flow that can legitimately take several minutes (see
// DECISIONS.md's synchronous-provisioning risk entry). The ALB in front of this endpoint
// already has no explicit idle_timeout override so it defaults to 60s, meaning the client
// is likely to see a disconnect well before the backend actually finishes even though the
// backend goes on to succeed. Our own client-level default (25s) would cut the request off
// even earlier than that, for no benefit, so this raises it close to (but still under) the
// ALB's 60s ceiling rather than fixing the deeper, already-accepted risk (out of scope here).
const SUBMISSION_TIMEOUT_MS = 58_000;

export const useSubmitOnboardingSignup = (token: string) => {
  const {
    mutateAsync,
    isPending: isLoading,
    error,
    reset,
  } = useMutation<{ data: OnboardingSignupResponse }, Error, OnboardingSignupRequest>({
    mutationFn: values =>
      api.post<OnboardingSignupResponse>(`public/onboarding-invite/${token}/submit`, values, {
        timeoutMs: SUBMISSION_TIMEOUT_MS,
      }),
  });

  return { submit: mutateAsync, isLoading, error, reset };
};
